export const state = () => ({
  managedProductList: [],
  managedProductListCancelToken: null,
  productBoostList: [],
});
